/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AvcInstancesApi extends runtime.BaseAPI {
    /**
     * Get a batch of instance based on their ids
     */
    async avcInstancesBatchGetPostRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/batchGet`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcInstanceBatchGet,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a batch of instance based on their ids
     */
    async avcInstancesBatchGetPost(requestParameters = {}, initOverrides) {
        const response = await this.avcInstancesBatchGetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of instances in the environment (excludes cluster owned instances).
     */
    async avcInstancesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling avcInstancesGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.clusterId !== undefined) {
            queryParameters['clusterId'] = requestParameters.clusterId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of instances in the environment (excludes cluster owned instances).
     */
    async avcInstancesGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List access keys
     */
    async avcInstancesInstanceIdAccessKeysGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdAccessKeysGet.');
        }
        const queryParameters = {};
        if (requestParameters.keyId !== undefined) {
            queryParameters['keyId'] = requestParameters.keyId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/accessKeys`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List access keys
     */
    async avcInstancesInstanceIdAccessKeysGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdAccessKeysGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an access key
     */
    async avcInstancesInstanceIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdAccessKeysKeyIdDelete.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling avcInstancesInstanceIdAccessKeysKeyIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/accessKeys/{keyId}`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an access key
     */
    async avcInstancesInstanceIdAccessKeysKeyIdDelete(requestParameters, initOverrides) {
        await this.avcInstancesInstanceIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an access key
     */
    async avcInstancesInstanceIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdAccessKeysKeyIdGet.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling avcInstancesInstanceIdAccessKeysKeyIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/accessKeys/{keyId}`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an access key
     */
    async avcInstancesInstanceIdAccessKeysKeyIdGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an access key
     */
    async avcInstancesInstanceIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdAccessKeysKeyIdPatch.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling avcInstancesInstanceIdAccessKeysKeyIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/accessKeys/{keyId}`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.basicIdentityPoolUserEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an access key
     */
    async avcInstancesInstanceIdAccessKeysKeyIdPatch(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new access key
     */
    async avcInstancesInstanceIdAccessKeysPostRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdAccessKeysPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/accessKeys`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.basicIdentityPoolUserKeyInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new access key
     */
    async avcInstancesInstanceIdAccessKeysPost(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdAccessKeysPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an instances and all its sub resources.
     */
    async avcInstancesInstanceIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an instances and all its sub resources.
     */
    async avcInstancesInstanceIdDelete(requestParameters, initOverrides) {
        await this.avcInstancesInstanceIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an instance.
     */
    async avcInstancesInstanceIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an instance.
     */
    async avcInstancesInstanceIdGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * [DUMMY DATA, NOT FULLY IMPLEMENTED YET] Get instance logs.
     */
    async avcInstancesInstanceIdLogsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdLogsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/logs`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * [DUMMY DATA, NOT FULLY IMPLEMENTED YET] Get instance logs.
     */
    async avcInstancesInstanceIdLogsGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdLogsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an instances.
     */
    async avcInstancesInstanceIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdPatch.');
        }
        if (requestParameters.avcInstanceEdit === null ||
            requestParameters.avcInstanceEdit === undefined) {
            throw new runtime.RequiredError('avcInstanceEdit', 'Required parameter requestParameters.avcInstanceEdit was null or undefined when calling avcInstancesInstanceIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcInstanceEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an instances.
     */
    async avcInstancesInstanceIdPatch(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a batch of instance tasks based on their ids
     */
    async avcInstancesInstanceIdTasksBatchGetPostRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksBatchGetPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/batchGet`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.distributedTaskBatchGet,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a batch of instance tasks based on their ids
     */
    async avcInstancesInstanceIdTasksBatchGetPost(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksBatchGetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List existing instance tasks.
     */
    async avcInstancesInstanceIdTasksGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksGet.');
        }
        const queryParameters = {};
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.activeness !== undefined) {
            queryParameters['activeness'] = requestParameters.activeness;
        }
        if (requestParameters.health !== undefined) {
            queryParameters['health'] = requestParameters.health;
        }
        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List existing instance tasks.
     */
    async avcInstancesInstanceIdTasksGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new instance task.
     */
    async avcInstancesInstanceIdTasksPostRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks`.replace(`{${'instanceId'}}`, String(requestParameters.instanceId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcInstanceTaskInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new instance task.
     */
    async avcInstancesInstanceIdTasksPost(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdDelete.');
        }
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/{taskId}`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdDelete(requestParameters, initOverrides) {
        await this.avcInstancesInstanceIdTasksTaskIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdGet.');
        }
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdGet.');
        }
        const queryParameters = {};
        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/{taskId}`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksTaskIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List instance task logs.
     */
    async avcInstancesInstanceIdTasksTaskIdLogsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdLogsGet.');
        }
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdLogsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.levels) {
            queryParameters['levels'] = requestParameters.levels;
        }
        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.alertId !== undefined) {
            queryParameters['alertId'] = requestParameters.alertId;
        }
        if (requestParameters.alertCode !== undefined) {
            queryParameters['alertCode'] = requestParameters.alertCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/{taskId}/logs`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List instance task logs.
     */
    async avcInstancesInstanceIdTasksTaskIdLogsGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksTaskIdLogsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdPatch.');
        }
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/{taskId}`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcInstanceTaskConfigGenericDistributedTaskEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdPatch(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksTaskIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Start an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdStartPostRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdStartPost.');
        }
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdStartPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/{taskId}/start`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Start an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdStartPost(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksTaskIdStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Stop an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdStopPostRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdStopPost.');
        }
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdStopPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/{taskId}/stop`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Stop an instance task.
     */
    async avcInstancesInstanceIdTasksTaskIdStopPost(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksTaskIdStopPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific instance task config version.
     */
    async avcInstancesInstanceIdTasksTaskIdVersionsVersionIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.instanceId === null ||
            requestParameters.instanceId === undefined) {
            throw new runtime.RequiredError('instanceId', 'Required parameter requestParameters.instanceId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdVersionsVersionIdGet.');
        }
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdVersionsVersionIdGet.');
        }
        if (requestParameters.versionId === null ||
            requestParameters.versionId === undefined) {
            throw new runtime.RequiredError('versionId', 'Required parameter requestParameters.versionId was null or undefined when calling avcInstancesInstanceIdTasksTaskIdVersionsVersionIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances/{instanceId}/tasks/{taskId}/versions/{versionId}`
                .replace(`{${'instanceId'}}`, String(requestParameters.instanceId))
                .replace(`{${'taskId'}}`, String(requestParameters.taskId))
                .replace(`{${'versionId'}}`, String(requestParameters.versionId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a specific instance task config version.
     */
    async avcInstancesInstanceIdTasksTaskIdVersionsVersionIdGet(requestParameters, initOverrides) {
        const response = await this.avcInstancesInstanceIdTasksTaskIdVersionsVersionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new instance.
     */
    async avcInstancesPostRaw(requestParameters, initOverrides) {
        if (requestParameters.avcInstanceInsert === null ||
            requestParameters.avcInstanceInsert === undefined) {
            throw new runtime.RequiredError('avcInstanceInsert', 'Required parameter requestParameters.avcInstanceInsert was null or undefined when calling avcInstancesPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcInstances`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcInstanceInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new instance.
     */
    async avcInstancesPost(requestParameters, initOverrides) {
        const response = await this.avcInstancesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AvcInstancesGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const AvcInstancesInstanceIdTasksGetActivenessEnum = {
    Active: 'ACTIVE',
    Stopped: 'STOPPED',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
};
/**
 * @export
 */
export const AvcInstancesInstanceIdTasksGetHealthEnum = {
    Ok: 'OK',
    Warning: 'WARNING',
    Critical: 'CRITICAL',
};
/**
 * @export
 */
export const AvcInstancesInstanceIdTasksGetViewEnum = {
    Slim: 'SLIM',
    Full: 'FULL',
};
/**
 * @export
 */
export const AvcInstancesInstanceIdTasksTaskIdGetViewEnum = {
    Slim: 'SLIM',
    Full: 'FULL',
};
/**
 * @export
 */
export const AvcInstancesInstanceIdTasksTaskIdLogsGetLevelsEnum = {
    Info: 'Info',
    Warning: 'Warning',
    Error: 'Error',
    Critical: 'Critical',
};
/**
 * @export
 */
export const AvcInstancesInstanceIdTasksTaskIdLogsGetTypesEnum = {
    Log: 'Log',
    AlertCreation: 'AlertCreation',
    AlertUpdate: 'AlertUpdate',
    AlertDeletion: 'AlertDeletion',
};
//# sourceMappingURL=AvcInstancesApi.js.map